import { render, staticRenderFns } from "./JustificationHeatmap.vue?vue&type=template&id=4a4278f3&scoped=true"
import script from "./JustificationHeatmap.vue?vue&type=script&lang=js"
export * from "./JustificationHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4278f3",
  null
  
)

export default component.exports